document.addEventListener("DOMContentLoaded", function () {
	const productItems = document.querySelectorAll(".upsell-container:not(.hidden) .upsell__product-item");
	const __productItems = document.querySelectorAll(".upsell-container.hidden .upsell__product-item");
	const cartItems = document.querySelectorAll(".cartitems--list .cart-item");

	productItems.forEach((item, index) => {
		// if the item exist in the cart remove upsell item
		cartItems.forEach((carItem) => {
			if (carItem.getAttribute("data-cartitem-id") == item.getAttribute("data-id")) {
				item.remove();

				// if upsell items has no products - remove layout
				if (document.querySelectorAll(".upsell-container:not(.hidden) .upsell__product-item").length == 0) {
					document.querySelector(".upsell-cross-sell").classList.remove("has-products");
				}
			}
		});

		item.querySelector("button.upsell__atc").addEventListener("click", async function (e) {
			e.preventDefault();

			const variantId = item.getAttribute("data-id");
			await addToCart(variantId);

			console.log("item", item, variantId);

			item.setAttribute("animate", "");

			// Wait for 600ms to remove the item
			setTimeout(() => {
				item.remove();
				__productItems[index].querySelector("button.upsell__atc").click();
			}, 600);
		});
	});

	async function addToCart(id) {
		// get the variantId

		let variantID = id;

		let formData = {
			items: [
				{
					id: variantID,
					quantity: 1,
				},
			],
		};

		await fetch(window.Shopify.routes.root + "cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(formData),
		})
			.then((response) => {
				return response.json();
			})
			.then((cart) => {
				return cart;
			})
			.catch((error) => {
				console.error("Error:", error);
			});
	}
});
